module.exports = {"610926100":"城关镇","610926101":"兴隆镇","610926102":"老县镇","610926103":"大贵镇","610926104":"三阳镇","610926105":"洛河镇","610926106":"广佛镇","610926107":"八仙镇","610926108":"长安镇","610926109":"正阳镇","610926110":"西河镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610926.json
// module id = 3017
// module chunks = 0